<template>
	<div class="pc100W">
			<van-swipe class="swipeHome" :autoplay="5000" lazy-render>
			  <van-swipe-item v-for="(image,index) in banners" :key="index">
				  <div style="position: relative;">
					  <van-row>
						<van-col span="24">
							<img :src="image.icon" />
						</van-col>
					  </van-row>
			      </div>
			    </van-swipe-item>
			</van-swipe>
		
	</div>
	<section class="pcMaxW pt-5">
		<div class="p-2 container">
			<div class="dFlex alCenter title">
				<h5 class="m-0">Trending Games</h5>
				<!-- <a href="#" class="btn btn-sm btn-outline-light">VIEW MORE</a> -->
			</div>
			<van-row gutter="30">
			  <van-col class="imgItems mb-3" span="6" v-for="(image,index) in images" :key="index">
				  <h6 class="fonts">{{ image.title }}</h6>
					<div class="items">
						<img :src="image.icon" />
						<div class="mask">
							<p class="m-0 textWhite30 lh15">{{ image.desc }}</p>
						</div>
					</div>
				</van-col>
			</van-row>
		</div>
	</section>
	<div class="pc100W agileits">
		<div class="pcMaxW">
			<van-swipe class="swipeDescs" :autoplay="5000" lazy-render>
			  <van-swipe-item v-for="(image,index) in banners" :key="index">
				  <div style="position: relative;">
					  <div class="bigTitle">{{ image.title }}</div>
					  <div class="desc">{{ image.desc }}</div>
					  <div class="dFlex" style="justify-content: center;"><a href="javascript:;" class="learn">Learn More</a></div>
			      </div>
			    </van-swipe-item>
				<template #indicator="{ active, total }">
				  <div class="pages">
						<a :class="{'active':index == active + 1}" v-for="index in total" :key="index">{{ index }}</a>
					</div>
				</template>
			</van-swipe>
		</div>
	</div>
</template>

<script setup>
	import { ref,onMounted,getCurrentInstance } from 'vue'
	import { useI18n } from "vue-i18n"
	
	const { proxy } = getCurrentInstance();
	
	const active = ref(0);
	const total = ref(2);
	const banners = ref([
		{ icon : require('@/assets/images/hongkong_000.jpg'), color: 'primary',
			title: '《永夜之城》',
			subTitle: 'MMORPG', 
			desc: '一款黑暗奇幻風 MMORPG，玩家將在被詛咒的永夜王國中冒險，挑戰古老的吸血鬼領主，探索失落的遺跡並奪回光明' ,
		},
		{ icon : require('@/assets/images/hongkong_001.jpg'), color: 'primary',
			title: '《星辰遠征》',
			subTitle: 'MMOARPG', 
			desc: '以宇宙為舞台的 MMOARPG，玩家可駕駛太空戰艦探索無盡星海，收集稀有資源，並在星際戰場中與其他艦隊展開激烈對決。' ,
		},
		{ icon : require('@/assets/images/hongkong_002.jpg'), color: 'primary',
			title: '《蒼穹神域》',
			subTitle: '魔幻MMORPG', 
			desc: '高自由度的奇幻世界，結合飛行戰鬥與大規模公會戰，玩家可化身神選勇者，駕馭飛翼探索天空大陸，守護人族與神域秩序。' ,
		}
	])
	const images = ref([
		{ icon : require('@/assets/images/1.jpg'), color: 'primary',
			title: '《永夜之城》',
			subTitle: 'MMORPG', 
			desc: '一款黑暗奇幻風 MMORPG，玩家將在被詛咒的永夜王國中冒險，挑戰古老的吸血鬼領主，探索失落的遺跡並奪回光明' ,
		},
		{ icon : require('@/assets/images/3.jpg'), color: 'dark',
			title: '《星辰遠征》',
			subTitle: 'MMOARPG', 
			desc: '以宇宙為舞台的 MMOARPG，玩家可駕駛太空戰艦探索無盡星海，收集稀有資源，並在星際戰場中與其他艦隊展開激烈對決。' ,
		},
		{ icon : require('@/assets/images/2.jpg'), color: 'warning',
			title: '《蒼穹神域》',
			subTitle: '魔幻MMORPG', 
			desc: '高自由度的奇幻世界，結合飛行戰鬥與大規模公會戰，玩家可化身神選勇者，駕馭飛翼探索天空大陸，守護人族與神域秩序。' ,
		},
		{ icon : require('@/assets/images/4.jpg'), color: 'warning',
			title: '《末日幻境》', 
			subTitle: 'MMO', 
			desc: '以末世題材打造的開放世界生存 MMO，玩家需收集資源、製作裝備，並在危險的廢墟中建立庇護所，與他人合作或爭奪生存資源。' ,
		}
	])
	const isLoading = ref(false)
	
	onMounted(()=>{
		
	})
</script>

<style lang="less" scoped>
	
	.swipeDescs{
		
		a.learn {
		    color: #fff;margin: 50px auto 0;
		    border: 2px solid #fff;
		    font-size: 14px;
		    padding: 7px 15px;
		    display: inline-block;
		}
	}
	.swipeHome{
		.van-swipe-item{
			img{
				width: 100%;
			}
			p{
				line-height: 1.6;
			}
		}
		.header-text{
			text-align: right;margin-top: 6%;
			h6{
				font-size: 20px;
				color: #fff;
				font-weight: 400;
				margin-bottom: 25px;
			}
			h4{
				font-size: 45px;
				text-transform: uppercase;
				margin-bottom: 25px;
				font-weight: 700;
			}
		}
	}
	.pages {
	    position: absolute;width: 10px;height: 60px;box-sizing: border-box;gap:15px;
	    right: 0;
	    top: 50%;
	    padding: 0;
		transform: translate(0,-50%);
		display: flex;flex-direction: column;
		a{
			display: inline-flex;width: 10px;height: 10px;
			align-items: center;justify-content: center;font-size: 0;
			border: 2px solid #e91e63;box-sizing: border-box;
			&.active{
				background: #e91e63;
			}
		}
		
	}
	.title{ 
		justify-content: center;
		margin-bottom: 40px;
		h5{
			font-size: 40px;
			text-decoration: none;
			color: #544FC3;
			text-align: center;
			font-family: 'Josefin Sans', sans-serif;
			letter-spacing: 1px;
		}
	}
	.imgItems{
		.fonts{
			font-size: 27px;color: #000;margin-bottom: 20px;
			text-align: center;
		}
		.items{
			position: relative;overflow: hidden;
			.mask{
				background-color: rgba(0, 0, 0, 0.67);
				top: -200px;
				-ms-filter: "progid: DXImageTransform.Microsoft.Alpha(Opacity=0)";
				filter: alpha(opacity=0);
				opacity: 0;
				-webkit-transition: all 0.3s ease-out 0.5s;
				-moz-transition: all 0.3s ease-out 0.5s;
				transition: all 0.3s ease-out 0.5s;
				width: 100%;padding: 6.5em 1.5em;height: 100%;box-sizing: border-box;
				position: absolute;overflow: hidden;z-index: 10;
				p{
					-webkit-transform: translateY(-200px);
					-moz-transform: translateY(-200px);
					-o-transform: translateY(-200px);
					-ms-transform: translateY(-200px);
					transform: translateY(-200px);
					-webkit-transition: all 0.2s ease-in-out 0.2s;
					-moz-transition: all 0.2s ease-in-out 0.2s;
					-o-transition: all 0.2s ease-in-out 0.2s;
					-ms-transition: all 0.2s ease-in-out 0.2s;
					transition: all 0.2s ease-in-out 0.2s;
					text-indent: 2em;
					font-size: 1em;line-height: 1.6;
					position: relative;
					color: #fff !important;
					padding: 0.5em 0;
					text-align: center;
					margin: 0;
				}
			}
			&:hover{
				.mask{
					top: 0;opacity: 1;
					p{
						-webkit-transform: translateY(0);
						-moz-transform: translateY(0);
						-o-transform: translateY(0);
						-ms-transform: translateY(0);
						transform: translateY(0);
					}
				}
			}
		}
		
		/deep/ img{
			width: 100%;vertical-align: middle;
		}
		.lh15{
			line-height: 1.5;
		}
	}
</style>